var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFolder1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.5H8M8 9.5H10.5M8 9.5V12M8 9.5V7",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 4.63321C1.33325 4.04485 1.33325 3.75067 1.37949 3.50563C1.58301 2.42691 2.42679 1.58313 3.50551 1.37961C3.75055 1.33337 4.04473 1.33337 4.63308 1.33337C4.89087 1.33337 5.01976 1.33337 5.14363 1.34496C5.67769 1.3949 6.18427 1.60473 6.59721 1.94705C6.69299 2.02645 6.78414 2.11759 6.96642 2.29987L7.33325 2.66671C7.87711 3.21056 8.14903 3.48249 8.47466 3.66366C8.65355 3.76318 8.84329 3.84178 9.04015 3.89789C9.39852 4.00004 9.78308 4.00004 10.5522 4.00004H10.8013C12.5562 4.00004 13.4337 4.00004 14.004 4.51302C14.0565 4.5602 14.1064 4.61013 14.1536 4.66259C14.6666 5.23294 14.6666 6.1104 14.6666 7.86531V9.33337C14.6666 11.8475 14.6666 13.1046 13.8855 13.8857C13.1045 14.6667 11.8474 14.6667 9.33325 14.6667H6.66659C4.15243 14.6667 2.89535 14.6667 2.1143 13.8857C1.33325 13.1046 1.33325 11.8475 1.33325 9.33337V4.63321Z",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder1);
export default __webpack_public_path__ + "static/media/addFolder1.b2811f26631eaa9a3c1754149ad53301.svg";
export { ForwardRef as ReactComponent };